import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/* Componente de formulario */
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

/* Importación de constantes */
import * as constants from '../../constants/general';

/* Importación de providers */
import { UtilsService } from '../../utils.service';
import { advertisement, ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-marchuelos',
  templateUrl: './marchuelos.page.html',
  styleUrls: ['./marchuelos.page.scss' , '../../../assets/scss/styles.scss'],
})
export class MarchuelosPage implements OnInit {
  previousResult: number = null;
  pulgada: number;
  rpm: number;
  result: number;
  tipo: string;
  mensaje: string;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  /* Variables encargadas del almacenamiento del formulario */
  public conversionForm: FormGroup = null;
  public unit: AbstractControl;
  public rpmValue: AbstractControl;
  public secondValue: AbstractControl;

  /* Lista */
  public unitList = constants.UNIT_LIST;

  /* Inputs */
  public pasoThread: string;

  constructor(private router: Router,
              public services: ServiceService,
              private _form_Builder: FormBuilder,
              private _utils: UtilsService ) { 

    //
    this.conversionForm = this._form_Builder.group({
      unit: ['', Validators.required],
      rpmValue: ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ],
      secondValue: ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ]
    });

    this.unit = this.conversionForm.controls.unit;
    this.rpmValue = this.conversionForm.controls.rpmValue;
    this.secondValue = this.conversionForm.controls.secondValue;
  }

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  public onChangeUnit() {
    if ( this.unit.value == 1 ) {
      this.pasoThread = 'hilos/in';
    } else if ( this.unit.value == 2 ) {
      this.pasoThread = 'Paso';
    }
  }
  isSharing:boolean = false;
  calcular() {
    if ( this.conversionForm.valid ) {

      if ( this.unit.value == 1 ) {
        const resultTmp = this.rpmValue.value / this.secondValue.value;
        this.result = this._utils.truncNumber( resultTmp , 4);
        this.mensaje = 'in/min';
      } else if ( this.unit.value == 2 ) {
        const resultTmp = this.rpmValue.value * this.secondValue.value
        this.result = this._utils.truncNumber( resultTmp , 3);
        this.mensaje = 'mm/min';
      }
      if(this.previousResult != this.result && !this.isSharing){
        this.previousResult = this.result;
        this.isSharing = true;
        setTimeout(()=>{ this.isSharing = false; },20000);
        this.services.addPointCalculator();
      }
    }
  }

  home() {
    return this.router.navigate(['/calculadora']);
  }

  routesTab(option: number) {
    switch (option){
      case 1: this.router.navigate(['/revo']); break;
      case 2: this.router.navigate(['/velocity']); break;
      case 3: this.router.navigate(['/avan']); break;
      case 4: this.router.navigate(['/marche']); break;
      case 5: this.router.navigate(['/torneado']); break;
    }
  }
}
